/**
 * Expects a config layers object with a linked list.
 * Link is defined by the title of the parent.
 * E.g.
 * "layers": [{title: 'layer1'}, {title: 'layer2', parent: 'layer1'}]
 */

import isNil from 'lodash/isNil'

import * as Model from 'api/model'
import GetTitleId from 'config/GetTitleId'

const GetChildLayers = (titleid) => {
  const childLayerConfs = []
  if (isNil(titleid) || titleid === '') {
    console.log('getChildLayers: Invalid parent titleid', titleid)
    return null
  }

  const state = window.store.getState()

  if (isNil(state) || isNil(state.layers) || state.layers.length === 0) {
    console.log('getChildLayers: No layers found in redux store!')
    return null
  }

  const bLocalDataSourceDetected = Model.get('app.LocalDataSourceDetected', false)

  // console.debug('GetChildLayers - looping through layers from redux state', state.layers)

  for (const layerConf of Object.values(state.layers)) {
    const { localDataSource, parent: parentTitle, selected, titleid: childTitleId, type } = layerConf
    // console.debug('GetChildLayers', childTitleId, parentTitle, selected, layerConf)

    if (!parentTitle) {
      // console.debug('GetChildLayers - layer without parent. Skipping.', childTitleId, parentTitle)
      continue
    }

    const parentTitleId = GetTitleId(parentTitle)
    if (titleid !== parentTitleId) {
      // console.debug('GetChildLayers - parent of layer does not match. Skipping.', childTitleId, parentTitleId)
      continue
    }

    const bLocalDataSource = localDataSource ?? false
    if (bLocalDataSource && !bLocalDataSourceDetected) {
      console.debug('GetChildLayers - local datasource required but not detected. Skipping.', childTitleId)
      continue
    }

    // Special case for WMS as they all have a parent of 'Whats Here' and could slip through the cracks
    const layerIsWms = type.toUpperCase().includes('WMS')
    if (layerIsWms && !selected) {
      // console.debug('GetChildLayers - layer is of type WMS but not selected. Skipping.', childTitleId)
      continue
    }

    // console.debug('GetChildLayers - layer with desired parent found!', childTitleId)

    childLayerConfs.push(layerConf)
  }

  return childLayerConfs
}

export default GetChildLayers
